// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1onBh","logo":"Header_logo__2wGdg","profile":"Header_profile__2w45l","menu":"Header_menu__1246g","iconMenu":"Header_iconMenu__3_p4V"};